import css from "./ImportRules.module.css";

import DropdownSection from "./DropdownSection";

function ImportRules() {
  return (
    <DropdownSection title={"Import Rules"}>
      <h3>Recipe name</h3>
      <p>The first line must be the recipe name followed by a blank line.</p>
      <h3>Ingredients</h3>
      <p>
        The Ingredients section must start with the header “Ingredients”
        followed by the list of ingredients. You should use one line per
        ingredient, with a blank line after the final ingredient to end the
        section.
      </p>
      <h3>Other sections (Mise En Place, Method, Notes)</h3>
      <p>
        All other sections must start with a header.
        <br />
        <br />
        Accepted headers are:
        <br />
        Mise En Place
        <br />
        Method
        <br />
        Notes
        <br />
        <br />
        Followed by the list of instructions, each instruction being followed by
        a blank line.
      </p>
      <h3>Recipe example</h3>
      <p>
        Recipe Name
        <br />
        <br />
        Ingredients
        <br />1 x first ingredient
        <br />2 x second ingredient
        <br />3 x third ingredient
        <br />
        <br />
        Mise En Place
        <br />
        Bowl 1
        <br />
        Cut first ingredient and put in bowl.
        <br />
        <br />
        Bowl 2
        <br />
        Cut second ingredient and put in bowl.
        <br />
        <br />
        Bowl 3
        <br />
        Cut third ingredient and put in bowl.
        <br />
        <br />
        Method
        <br />
        Place bowl 1 into the pan and cook for 5 minutes.
        <br />
        <br />
        Place bowl 2 into the pan and cook for 5 minutes.
        <br />
        <br />
        Place bowl 3 into the pan and cook for 5 minutes. Then serve.
        <br />
        <br />
        Notes
        <br />
        Note one this is an example note.
        <br />
        Second line of note one.
        <br />
        <br />
        Note two this is an example note.
        <br />
        Second line of note two.
        <br />
        <br />
      </p>
    </DropdownSection>
  );
}

export default ImportRules;
